import { API_ROUTES, API_ROUTE_V2_PREFIX_HTTPS } from "@tm/api-utils";
import { setURLQueryParams } from "@tm/insurance/utils";
import { LOB, PARTNER } from "@tm/isomorphic-utils";
import { openCheckoutPage } from "./checkout";

export interface UploadTemplateResponse {
  responseStatus: string;
  message?: string;
  data?: {
    status: string;
    checkoutUrl?: string;
  };
}

export const uploadTemplate = async (
  file: File,
  quoteId: string,
  itineraryId: string,
  isExcelBypass: boolean
): Promise<UploadTemplateResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  const params = {
    quoteId: quoteId,
    itineraryId: itineraryId,
    isExcelBypass: isExcelBypass,
    lob: LOB.MYPARTNER,
  };
  const urlParams = setURLQueryParams(params);

  const response = await fetch(
    `${API_ROUTE_V2_PREFIX_HTTPS}/${PARTNER.MMT}/${API_ROUTES.UPLOAD_TEMPLATE}${
      urlParams ? `?${urlParams}` : ""
    }`,
    {
      method: "POST",
      body: formData,
    }
  );

  if (!response.ok) {
    throw new Error(`Upload failed with status: ${response.status}`);
  }

  const responseData: UploadTemplateResponse = await response.json();

  // Check if response indicates failure
  if (
    responseData.responseStatus !== "SUCCESS" ||
    responseData.data?.status !== "SUCCESS"
  ) {
    throw new Error(responseData.message || "Upload failed");
  }

  // Handle checkout URL redirect if present
  if (responseData.data?.checkoutUrl) {
    openCheckoutPage(responseData.data.checkoutUrl);
  }

  return responseData;
};
